import {
    WithStyles,
    withStyles,
  } from "@material-ui/core";
  import React, { Component } from "react";
  import { connect } from "react-redux";
  import { userStyles } from "../styles";
  import TopHeader from "./TopHeader";
  import NavHeader from "./NavHeader";
  import ACLService from '../../acl/services/aclService'
  import {
    switchSelectedTab,
  } from "../actions/userActions";
import { withRouter } from "react-router-dom";

  
  interface UserManagementProps extends WithStyles<typeof userStyles> {
    selectedTab:any;
    switchSelectedTab: any;
    isPostExpiryDays: any;
    history: any;
  }
  interface UserManagementState {
    selectedTab: string,
    userDetails: any	,
}
  
  class UserManagement extends Component<UserManagementProps, UserManagementState> {
    constructor(props:UserManagementProps){
		super(props);
    if(!ACLService.isSuperAdmin()) {
      this.props.history.push('/mylibrary')
    }
		this.state = {
            selectedTab: '',
            userDetails: {},
        };
    }  
    componentDidMount() {
        const userD = ACLService.getUserDetailsFromStorage();
        this.setState({userDetails: userD});     
    }

      componentDidUpdate(prevProps: any, prevState: any) {
        if (prevState.userDetails !== this.state.userDetails) {
            this.changeNavValue(0);
        }
      }
      static getDerivedStateFromProps(nextProps: any, prevState: any) {
        return {
          selectedTab: nextProps.selectedTab ? nextProps.selectedTab : prevState.selectedTab,
        };
      }

    changeNavValue = (value: any) => {
      if(this.state.userDetails.authenticatedUser.isSuperAdmin){
        switch(value) {
          case 0: return this.setState({selectedTab: "Clients"});
          case 1: return this.setState({selectedTab: "Roles"});
          case 2: return this.setState({selectedTab: "Users"});
      }
      } else if(this.state.userDetails.authenticatedUser.isAdmin)
      {
        switch(value) {
          case 0: return this.setState({selectedTab: "Roles"})
          case 1: return this.setState({selectedTab: "Users"});
      }
      } else {
        switch(value) {
          case 0: return this.setState({selectedTab: "Users"})
      }
      }
      };
    render() {
        const { selectedTab, userDetails } = this.state;
      return (
        <div>
          <NavHeader onTabChange={this.changeNavValue} userDetails={userDetails} isPostExpiryDays={this.props.isPostExpiryDays}/>
        </div>
      );
    }
  }

  const mapStateToProps = (state: any) => ({
    selectedTab: state.clientManagement.usersManagement.selectedTab,
    isPostExpiryDays: state.loginData.userData && state.loginData.userData.isPostExpiryDays
  });
  
  const mapDispatchToProps = {
    switchSelectedTab,
  };
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
      // @ts-ignore
  )(withStyles(userStyles)(withRouter(UserManagement)));
  